import { normalizeTenantPlan } from '../utils/planAccess';

const PLAN_CARDS = {
    free: {
        title: 'Pulsuz',
        price: '0 AZN / aylıq',
        tone: 'border-slate-200 bg-slate-50',
        accent: 'bg-slate-900 text-white',
        badge: null,
        features: [
            { label: 'Maksimum 4 masa', included: true },
            { label: 'Maksimum 3 kateqoriya', included: true },
            { label: 'Limitli menyu məhsulu: cəmi 10', included: true },
            { label: 'Limitli ofisiant: cəmi 1', included: true },
            { label: 'Limitli menyu şəkli: 0', included: true },
            { label: 'Limitli printer: cəmi 1', included: true },
            { label: 'Kassir', included: false },
            { label: 'Mətbəx çapı', included: false },
            { label: 'Müştəri çeki çapı', included: false },
            { label: 'Hesabatlar', included: false },
            { label: 'Kassa hesabatı', included: false },
            { label: 'Satış', included: false },
            { label: 'Ofis idarəsi', included: false },
            { label: 'Fiskal kassa inteqrasiyası', included: false },
            { label: 'Giriş ekranı və çek brendingi', included: false },
            { label: 'Zal / kabinet / otaq idarəsi', included: false },
            { label: 'Anbar və texkarta', included: false }
        ]
    },
    basic: {
        title: 'Sadə',
        price: '44.99 AZN / aylıq',
        tone: 'border-amber-300 bg-gradient-to-b from-amber-50 to-white',
        accent: 'bg-amber-500 text-white',
        badge: 'Ən çox seçilən',
        features: [
            { label: 'Masa limiti yoxdur', included: true },
            { label: 'Kateqoriya limiti yoxdur', included: true },
            { label: 'Limitli menyu məhsulu: cəmi 50', included: true },
            { label: 'Limitli ofisiant: cəmi 2', included: true },
            { label: 'Limitli kassir: cəmi 1', included: true },
            { label: 'Menyu şəkli: maksimum 3 məhsul', included: true },
            { label: 'Mətbəx çapı', included: true },
            { label: 'Müştəri çeki çapı', included: true },
            { label: 'Hesabatlar (restoran, kassa, ofisiant)', included: true },
            { label: 'Kassa hesabatı', included: true },
            { label: 'Fiskal kassa inteqrasiyası', included: true },
            { label: 'Giriş ekranı və çek brendingi', included: true },
            { label: 'Zal / kabinet / otaq idarəsi', included: false },
            { label: 'Anbar və texkarta', included: false },
            { label: 'Satış və ofis hesabatları', included: false },
            { label: 'Kassa → Ofis', included: false },
            { label: 'Alışlar / bazarlıq', included: false },
            { label: 'Xərclər idarəsi', included: false },
            { label: 'İşçilər / maaş', included: false },
            { label: 'Kirayə (evlər)', included: false }
        ]
    },
    pro: {
        title: 'Pro',
        price: '89 AZN / aylıq',
        tone: 'border-emerald-200 bg-emerald-50',
        accent: 'bg-emerald-600 text-white',
        badge: null,
        features: [
            { label: 'Masa limiti yoxdur', included: true },
            { label: 'Kateqoriya limiti yoxdur', included: true },
            { label: 'Menyu məhsulu limiti yoxdur', included: true },
            { label: 'Ofisiant limiti yoxdur', included: true },
            { label: 'Kassir limiti yoxdur', included: true },
            { label: 'Anbardar', included: true },
            { label: 'Mətbəx çapı', included: true },
            { label: 'Müştəri çeki çapı', included: true },
            { label: 'Tam hesabatlar (satış, ofis, xərclər, alışlar)', included: true },
            { label: 'Kassa hesabatı', included: true },
            { label: 'Fiskal kassa inteqrasiyası', included: true },
            { label: 'Kassa → Ofis idarəsi', included: true },
            { label: 'Giriş ekranı və çek brendingi', included: true },
            { label: 'Zal / kabinet / otaq idarəsi', included: true },
            { label: 'Anbar və texkarta', included: true },
            { label: 'Alışlar / bazarlıq', included: true },
            { label: 'Xərclər idarəsi', included: true },
            { label: 'İşçilər / maaş', included: true },
            { label: 'Kirayə (evlər)', included: true }
        ]
    }
};

const splitFeatures = (features) => ({
    included: features.filter((feature) => feature.included),
    excluded: features.filter((feature) => !feature.included)
});

const iconFor = (included) => (included ? '✓' : '✕');

const UpgradeModal = ({
    open,
    onClose,
    title = 'Bu funksiya paketinizdə aktiv deyil',
    message = 'Bu funksiyadan istifadə etmək üçün planınızı yüksəldin.',
    plans = ['basic', 'pro'],
    currentPlan = 'free'
}) => {
    if (!open) return null;

    const normalizedCurrentPlan = normalizeTenantPlan(currentPlan);
    const normalizedPlans = (Array.isArray(plans) ? plans : [plans])
        .map((planKey) => normalizeTenantPlan(planKey))
        .filter(Boolean);

    const requestedPlans = Array.from(new Set(normalizedPlans));
    const visiblePlans = normalizedCurrentPlan === 'free'
        ? Array.from(new Set(['free', ...requestedPlans]))
        : Array.from(new Set([normalizedCurrentPlan, ...requestedPlans])).filter((planKey) => planKey !== 'free');

    const maxWidthClass = visiblePlans.length === 2 ? 'max-w-3xl' : 'max-w-5xl';

    return (
        <div
            className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-950/55 p-4"
            onClick={(e) => e.target === e.currentTarget && onClose()}
        >
            <div className={`flex max-h-[92vh] w-full ${maxWidthClass} flex-col overflow-hidden rounded-[28px] bg-white shadow-2xl`}>
                <div className="border-b border-slate-100 p-5 sm:p-7">
                    <div className="flex items-start gap-4">
                        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-amber-100 text-3xl">
                            🔒
                        </div>
                        <div>
                            <h3 className="text-xl font-black text-slate-900">{title}</h3>
                            <p className="mt-1 text-sm leading-6 text-slate-500">{message}</p>
                        </div>
                    </div>
                </div>

                <div className="overflow-y-auto p-5 sm:p-7">
                    <div className={`grid gap-4 ${visiblePlans.length === 2 ? 'lg:grid-cols-2' : 'lg:grid-cols-3'}`}>
                        {visiblePlans.map((planKey) => {
                            const card = PLAN_CARDS[planKey];
                            const isCurrent = normalizedCurrentPlan === planKey;
                            const { included, excluded } = splitFeatures(card.features);

                            return (
                                <div
                                    key={planKey}
                                    className={`rounded-3xl border p-5 ${card.tone} ${isCurrent ? 'ring-2 ring-slate-900/10' : ''}`}
                                >
                                    <div className="mb-4 flex items-start justify-between gap-3">
                                        <div>
                                            <div className="text-lg font-black text-slate-900">{card.title}</div>
                                            <div className="mt-1 text-xl font-black text-slate-900">{card.price}</div>
                                            <div className="mt-1 text-xs font-medium text-slate-500">
                                                {isCurrent ? 'Hazırkı paket' : 'Tövsiyə olunan seçim'}
                                            </div>
                                        </div>
                                        {isCurrent ? (
                                            <span className={`rounded-full px-3 py-1 text-xs font-bold ${card.accent}`}>
                                                Hazırkı paket
                                            </span>
                                        ) : card.badge ? (
                                            <span className="rounded-full bg-amber-500 px-3 py-1 text-xs font-bold text-white">
                                                {card.badge}
                                            </span>
                                        ) : null}
                                    </div>

                                    <div className="space-y-2.5">
                                        {included.map((feature) => (
                                            <div key={feature.label} className="flex items-start gap-2 text-sm">
                                                <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-emerald-100 text-xs font-bold text-emerald-700">
                                                    {iconFor(true)}
                                                </span>
                                                <span className="text-slate-700">{feature.label}</span>
                                            </div>
                                        ))}
                                        {excluded.length > 0 && (
                                            <div className="pt-3">
                                                <div className="mb-2 text-[11px] font-bold uppercase tracking-[0.18em] text-slate-400">
                                                    Daxil deyil
                                                </div>
                                                <div className="space-y-2.5">
                                                    {excluded.map((feature) => (
                                                        <div key={feature.label} className="flex items-start gap-2 text-sm">
                                                            <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-rose-100 text-xs font-bold text-rose-600">
                                                                {iconFor(false)}
                                                            </span>
                                                            <span className="text-slate-400">{feature.label}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="border-t border-slate-100 p-5 sm:p-6">
                    <div className="flex justify-end">
                        <button
                            type="button"
                            onClick={onClose}
                            className="rounded-2xl bg-slate-900 px-5 py-3 text-sm font-bold text-white transition-all hover:bg-slate-700"
                        >
                            Bağla
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpgradeModal;
